import VueMonthlyPicker from './components/VueMonthlyPicker'
import './styles/lib.scss'

export default VueMonthlyPicker



// WEBPACK FOOTER //
// ./src/lib.js